import React from 'react'
import { ReactComponent as StarSvg } from 'resources/svg/icons/star.svg'
import { Item } from './styled'

interface Props {
  points?: any
  author?: string
  review: string
}
export const ReviewItem: React.FC<Props> = ({ points, author, review }) => {
  return (
    <Item>
      <div
        className='item__rating'
      >
        {
          (Array(Math.floor(parseFloat(`${points}`))))
            .fill(true)
            .map((e, r) => <StarSvg key={r} />)
        }
      </div>
      <div
        className='item__review'
      >
        {review}
      </div>
      <div
        className='item__author'
      >
        - {author}
      </div>
    </Item>
  )
}
